module.exports = __webpack_public_path__ + "img/merbear_pineapple_orange.ab2d7ccb.png";